import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

type LoadingSpinnerColor = 'active' | 'success' | 'error' | 'warning';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'nrc-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingSpinnerComponent implements OnChanges {
  @Input() public percentage: number | null = null;
  @Input() public color: LoadingSpinnerColor = 'active';

  // Default colors
  public currentFillColor = '#00bcd4';
  public currentTextColor = '#00bcd4';
  public currentBGColor = 'rgba(0, 188, 212, 0.2)'; // More transparent background

  /**
   * @param changes
   */
  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['color']) {
      const colorMap = {
        active: '#00bcd4',
        success: '#4caf50',
        error: '#f44336',
        warning: '#ff9800'
      };

      const baseColor = colorMap[this.color];

      this.currentFillColor = baseColor;
      this.currentTextColor = baseColor;
      this.currentBGColor = this.hexToRgba(baseColor, 0.2); // 20% opacity for background
    }
  }

  /**
   *
   * @param hex
   * @param alpha
   *
   * @returns
   */
  private hexToRgba(hex: string, alpha: number): string {
    // Remove # if present
    hex = hex.replace('#', '');

    // Parse hex values
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
}
